(function () {
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function initGlobal() {
    var mt = $('[data-menu-toggle]'), nav = $('[data-nav]');
    if (mt && nav && !mt._b) {
      mt._b = true;
      mt.addEventListener('click', function () { mt.setAttribute('aria-expanded', nav.classList.toggle('open')); });
    }
    var st = $('[data-search-toggle]'), sb = $('[data-search]');
    if (st && sb && !st._b) {
      st._b = true;
      st.addEventListener('click', function () {
        sb.hidden = !sb.hidden;
        if (!sb.hidden) { var i = $('input[type=search]', sb); if (i) i.focus(); }
      });
    }
  }

  function initSlider(root) {
    if (root._b) return; root._b = true;
    var track = $('[data-track]', root), slides = $$('[data-slide]', root), dots = $$('[data-dot]', root);
    if (slides.length < 2) return;
    var i = 0, timer;
    function mark() { dots.forEach(function (d, n) { d.classList.toggle('active', n === i); }); }
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); mark();
    }
    var p = $('[data-prev]', root), nx = $('[data-next]', root);
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { i = Math.round(track.scrollLeft / track.clientWidth); mark(); }, 80);
    });
    mark();
    if (root.dataset.autoplay === 'true') {
      var ms = (parseInt(root.dataset.speed, 10) || 5) * 1000;
      var start = function () { stop(); timer = setInterval(function () { go(i + 1); }, ms); };
      var stop = function () { clearInterval(timer); };
      root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
      root.addEventListener('touchstart', stop, { passive: true });
      start();
    }
  }

  function initCountdown(el) {
    if (el._b) return; el._b = true;
    var end = new Date((el.dataset.end || '').replace(' ', 'T')).getTime();
    if (isNaN(end)) return;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var d = Math.max(0, end - Date.now()), s = Math.floor(d / 1000);
      $('[data-d]', el).textContent = pad(Math.floor(s / 86400));
      $('[data-h]', el).textContent = pad(Math.floor(s % 86400 / 3600));
      $('[data-m]', el).textContent = pad(Math.floor(s % 3600 / 60));
      $('[data-s]', el).textContent = pad(s % 60);
    }
    tick(); setInterval(tick, 1000);
  }

  function initProduct(root) {
    if (root._b) return; root._b = true;
    var vj = $('[data-variants]', root); if (!vj) return;
    var variants = JSON.parse(vj.textContent);
    var idInput = $('[data-variant-id]', root), selects = $$('[data-option]', root);
    var buy = $('[data-buy]', root), price = $('[data-price]', root), compare = $('[data-compare]', root), add = $('[data-add]', root);
    var slidesEls = $$('.gallery-slide', root), thumbs = $$('[data-thumb]', root);

    function show(id) {
      slidesEls.forEach(function (s) { s.classList.toggle('active', s.dataset.media == id); });
      thumbs.forEach(function (t) { t.classList.toggle('active', t.dataset.thumb == id); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.thumb); }); });

    function update() {
      var o = selects.map(function (s) { return s.value; });
      var v = variants.filter(function (x) { return x.options.every(function (val, n) { return val === o[n]; }); })[0];
      if (!v) { if (buy) buy.disabled = true; add.disabled = true; add.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      price.textContent = v.price;
      price.classList.toggle('is-sale', !!v.compare);
      if (compare) { compare.hidden = !v.compare; compare.textContent = v.compare || ''; }
      if (buy) buy.disabled = !v.available;
      add.disabled = !v.available; add.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.media) show(v.media);
      history.replaceState(null, '', '?variant=' + v.id);
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    $$('[data-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var q = $('input[name=quantity]', root);
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      });
    });
  }

  function initFilters(form) {
    if (form._b) return; form._b = true;
    $$('input[type=checkbox],[data-auto-submit]', form).forEach(function (el) {
      el.addEventListener('change', function () { form.submit(); });
    });
  }

  function init() {
    initGlobal();
    $$('[data-slider]').forEach(initSlider);
    $$('[data-countdown]').forEach(initCountdown);
    $$('[data-product]').forEach(initProduct);
    $$('[data-filter-form]').forEach(initFilters);
  }
  var toastEl, toastT;
  function toast(html, err) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = html; toastEl.classList.toggle('error', !!err); toastEl.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('show'); }, 3500);
  }
  // Quick add: add to cart without leaving the page ("Buy now" submits normally and goes to checkout)
  document.addEventListener('submit', function (e) {
    var form = e.target, btn = e.submitter;
    if (!form.matches || !form.matches('[data-card-form]') || !btn || btn.name !== 'add') return;
    e.preventDefault();
    var label = btn.textContent; btn.classList.add('is-loading'); btn.textContent = 'Adding...';
    var base = form.action.replace(/\/cart\/add.*$/, '');
    fetch(base + '/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.d.description || res.d.message || 'Could not add this item.', true); return; }
        return fetch(base + '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          $$('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
          toast('Added to cart <a href="' + base + '/cart">View cart</a>');
        });
      })
      .catch(function () { form.submit(); })
      .then(function () { btn.classList.remove('is-loading'); btn.textContent = label; });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
